module.exports = __webpack_public_path__ + "media/add_a_lease.4457cbe6.svg";